export default {"src":"/_next/static/media/page-loader.46514bdc.svg","height":40,"width":40};